export interface Product {
  id: string;
  name: string;
  description: string;
  price: number;
  originalPrice?: number;
  rating: number;
  reviewCount: number;
  image: string;
  category: string;
  brand: string;
  guruRecommended: boolean;
  guruName?: string;
  guruSpecialty?: string;
  inStock: boolean;
  shipping: 'free' | 'paid' | 'prime';
  tags: string[];
  affiliateLink?: string;
}

export interface Category {
  id: string;
  name: string;
  icon: string;
  productCount: number;
}

export const exampleProducts: Product[] = [
  {
    id: '1',
    name: 'Continuous Glucose Monitor Starter Kit',
    description: 'Professional-grade CGM system for diabetes management with 14-day sensor and mobile app integration.',
    price: 299.99,
    originalPrice: 399.99,
    rating: 4.8,
    reviewCount: 1247,
    image: '/products/cgm-kit.jpg',
    category: 'diabetes',
    brand: 'Dexcom',
    guruRecommended: true,
    guruName: 'Dr. Sarah Chen',
    guruSpecialty: 'Endocrinology',
    inStock: true,
    shipping: 'free',
    tags: ['diabetes', 'monitoring', 'professional-grade'],
    affiliateLink: 'https://amazon.com/dp/B08XYZ123'
  },
  {
    id: '2',
    name: 'Organic Protein Powder - Plant Based',
    description: 'Complete amino acid profile with 25g protein per serving, perfect for post-workout recovery.',
    price: 45.99,
    rating: 4.6,
    reviewCount: 892,
    image: '/products/protein-powder.jpg',
    category: 'nutrition',
    brand: 'Vital Proteins',
    guruRecommended: true,
    guruName: 'Coach Mike Rodriguez',
    guruSpecialty: 'Fitness & Nutrition',
    inStock: true,
    shipping: 'prime',
    tags: ['protein', 'plant-based', 'recovery'],
    affiliateLink: 'https://amazon.com/dp/B07ABC456'
  },
  {
    id: '3',
    name: 'Smart Blood Pressure Monitor',
    description: 'Wireless BP monitor with smartphone connectivity and unlimited user profiles.',
    price: 89.99,
    originalPrice: 129.99,
    rating: 4.7,
    reviewCount: 2156,
    image: '/products/bp-monitor.jpg',
    category: 'monitoring',
    brand: 'Omron',
    guruRecommended: false,
    inStock: true,
    shipping: 'free',
    tags: ['blood pressure', 'wireless', 'smart'],
    affiliateLink: 'https://amazon.com/dp/B06DEF789'
  },
  {
    id: '4',
    name: 'Meditation App Premium Subscription',
    description: '1-year premium access to guided meditations, sleep stories, and mindfulness exercises.',
    price: 59.99,
    originalPrice: 99.99,
    rating: 4.9,
    reviewCount: 3421,
    image: '/products/meditation-app.jpg',
    category: 'mental-health',
    brand: 'Calm',
    guruRecommended: true,
    guruName: 'Dr. Emily Watson',
    guruSpecialty: 'Mental Health',
    inStock: true,
    shipping: 'free',
    tags: ['meditation', 'mental-health', 'subscription'],
    affiliateLink: 'https://calm.com/premium'
  },
  {
    id: '5',
    name: 'Portable ECG Monitor',
    description: 'Personal ECG device that connects to your smartphone for heart rhythm monitoring.',
    price: 199.99,
    rating: 4.5,
    reviewCount: 567,
    image: '/products/ecg-monitor.jpg',
    category: 'monitoring',
    brand: 'KardiaMobile',
    guruRecommended: false,
    inStock: true,
    shipping: 'paid',
    tags: ['heart', 'ecg', 'monitoring'],
    affiliateLink: 'https://amazon.com/dp/B08GHI234'
  },
  {
    id: '6',
    name: 'Essential Oils Wellness Set',
    description: 'Curated collection of therapeutic-grade essential oils for stress relief and wellness.',
    price: 79.99,
    rating: 4.4,
    reviewCount: 1234,
    image: '/products/essential-oils.jpg',
    category: 'wellness',
    brand: 'doTERRA',
    guruRecommended: true,
    guruName: 'Dr. Emily Watson',
    guruSpecialty: 'Mental Health',
    inStock: true,
    shipping: 'free',
    tags: ['essential oils', 'wellness', 'stress-relief'],
    affiliateLink: 'https://amazon.com/dp/B09XYZ567'
  }
];

export const exampleCategories: Category[] = [
  { id: 'all', name: 'All Products', icon: '🛍️', productCount: exampleProducts.length },
  { id: 'diabetes', name: 'Diabetes Care', icon: '🩸', productCount: 1 },
  { id: 'nutrition', name: 'Nutrition', icon: '🥗', productCount: 1 },
  { id: 'monitoring', name: 'Health Monitoring', icon: '📊', productCount: 2 },
  { id: 'mental-health', name: 'Mental Health', icon: '🧠', productCount: 1 },
  { id: 'wellness', name: 'Wellness', icon: '🌸', productCount: 1 }
]; 